module.exports = __webpack_public_path__ + "static/media/login-bkg.3551374f.png";